import {
  addDays,
  addMonths,
  differenceInCalendarDays,
  endOfMonth,
  getDaysInMonth,
  startOfDay,
  startOfMonth,
  formatDistanceStrict,
} from 'date-fns';

export const getDueDate = (dueDate) => {
  const today = new Date();
  const futureDate = new Date(dueDate);
  const interval = differenceInCalendarDays(futureDate, today);
  const positiveDiff = interval > 0 ? interval : interval * -1;
  const formattedDate = formatDistanceStrict(startOfDay(today), startOfDay(futureDate));
  if (interval === 0) {
    return 'Today';
  }
  if (interval === 1) {
    return 'Tomorrow';
  }
  if (interval < 0) {
    return `${formattedDate} ago`;
  }
  return `in ${formattedDate}`;
};

export const getDaysAgo = (ts) => {
  if (ts) {
    const date1 = new Date();
    const date2 = new Date(ts);
    const diff = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);
    const positiveDiff = diff > 0 ? diff : diff * -1;
    return `${positiveDiff} days ago`;
  }
};

export const formatTime = (d) => {
  const date = d ? new Date(d) : new Date();
  const h = date.getHours();
  let m = date.getMinutes();
  if (m < 10) {
    m = `0${m}`;
  }
  return `${h % 12 || 12}:${m} ${h < 12 ? 'A' : 'P'}M`;
};

const getMonthMidDate = (dateTS) => {
  const date = new Date(dateTS);

  const daysInMonth = getDaysInMonth(date);

  return addDays(date, Math.floor(daysInMonth / 2));
};

const getQuarterTicks = (startTS) => {
  const ticksTS = [];

  const date = startOfMonth(new Date(startTS));

  ticksTS.push(date);
  ticksTS.push(getMonthMidDate(date));
  ticksTS.push(addMonths(date, 1));
  ticksTS.push(getMonthMidDate(addMonths(date, 1)));
  ticksTS.push(addMonths(date, 2));
  ticksTS.push(getMonthMidDate(addMonths(date, 2)));
  ticksTS.push(startOfDay(endOfMonth(addMonths(date, 2))));

  return ticksTS.map((date) => date.getTime());
};

const getHalfYearTicks = (startTS, endTS) => {
  const ticksTS = [];

  const date = startOfMonth(new Date(startTS));

  ticksTS.push(date);
  ticksTS.push(addMonths(date, 1));
  ticksTS.push(addMonths(date, 2));
  ticksTS.push(addMonths(date, 3));
  ticksTS.push(addMonths(date, 4));
  ticksTS.push(addMonths(date, 5));
  ticksTS.push(startOfDay(endOfMonth(addMonths(date, 5))));

  return ticksTS.map((date) => date.getTime());
};

const getYearTicks = (startTS, endTS) => {
  const ticksTS = [];

  const date = startOfMonth(new Date(startTS));

  ticksTS.push(date);
  ticksTS.push(addMonths(date, 2));
  ticksTS.push(addMonths(date, 4));
  ticksTS.push(addMonths(date, 6));
  ticksTS.push(addMonths(date, 8));
  ticksTS.push(addMonths(date, 10));
  ticksTS.push(startOfDay(endOfMonth(addMonths(date, 11))));

  return ticksTS.map((date) => date.getTime());
};

export const getXAxisTicks = (startTS, endTS) => {
  // expectations:
  // startDate is either Jan 1, Apr1, July1, Oct1 and starts on 0 Hr 0 min 0 sec
  // endDate ends on 23rd hr and 59 min 0 sec
  // duration can be quarter, half year and year.
  // ideally we should discard any other thing.

  const diffInCalendarDays = differenceInCalendarDays(endTS, startTS);

  const estimatedDifferenceInMonths = Math.round(diffInCalendarDays / 30);

  if (estimatedDifferenceInMonths === 3) {
    // quarter
    return getQuarterTicks(startTS);
  }
  if (estimatedDifferenceInMonths === 6) {
    // half year
    return getHalfYearTicks(startTS);
  }
  if (estimatedDifferenceInMonths === 12) {
    // full year
    return getYearTicks(startTS);
  }
  // some other duration
  return [];
};
